import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const submitVolunteerForm = createAsyncThunk(
  "volunteer/submit",
  async (formData, { rejectWithValue }) => {
    try {
      await new Promise((res) => setTimeout(res, 1500));
      return formData;
    } catch (err) {
      return rejectWithValue("Failed to submit form");
    }
  }
);

const volunteerSlice = createSlice({
  name: "volunteer",
  initialState: {
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitVolunteerForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitVolunteerForm.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(submitVolunteerForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default volunteerSlice.reducer;
